<template>
  <input
    ref="input"
    type="text"
    class="ic-field__input"
    :placeholder="placeholder"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
import { loadGoogleMaps } from '@/services/googleMaps.js';

export default {
  name: 'AddressAutocompleteField',
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: 'Indirizzo' },
  },
  emits: ['update:modelValue'],
  async mounted() {
    if (!(window.google && window.google.maps && window.google.maps.places)) {
      try { await loadGoogleMaps(); } catch (e) { return; }
    }
    if (!(window.google && window.google.maps && window.google.maps.places)) return;
    this.autocomplete = new window.google.maps.places.Autocomplete(this.$refs.input, {
      types: ['address'],
      componentRestrictions: { country: 'it' },
    });
    this.autocomplete.addListener('place_changed', this.onPlaceChanged);
  },
  unmounted() {
    if (this.autocomplete && window.google) {
      try { window.google.maps.event.clearInstanceListeners(this.autocomplete); } catch (e) { /* already cleared */ }
      this.autocomplete = null;
    }
  },
  methods: {
    onPlaceChanged() {
      const place = this.autocomplete.getPlace();
      const value = (place && place.formatted_address) || this.$refs.input.value;
      this.$emit('update:modelValue', value);
    },
  },
};
</script>
